/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { Button, Table, Form, Modal } from "react-bootstrap";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import { RegulationContext } from "../../../App";
import { FcFinePrint } from "react-icons/fc";

import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
  STATUS
} from "../../../core/constants/common";
import FormService from "../../../core/service/FormService";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import nodataimg from "../../../images/nodatafound.png";
import Utils from "../../../core/utilities/Utils";

const SubmissionStatusModal = ({ t, isSubmissionStatus, submission, callbackSubmissionStatus }) => {
  const [show, setShow] = useState(isSubmissionStatus ? true : false);
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [forms, setForms] = useState([]);
  const [isCheck, setIsCheck] = useState([]);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";

  const handleClose = () => {
    setShow(false);
    callbackSubmissionStatus(false);
  };
  const searchKey = "";
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (glbRegulationId) {
      getForms(0, itemsPerPage, searchKey, sortField, glbRegulationId);
    } else {
      getForms(0, itemsPerPage, searchKey, sortField);
    }
  }, [isSubmissionStatus]);
  const getForms = (
    pageNumber,
    itemsPerPageVal,
    searchVal = "",
    sortField,
    glbRegulationId = ""
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    var data = JSON.parse(localStorage.getItem("authority"));
    const company = data.profile.company.id;
    var string = Utils.generateUrlParamCompanyRegulationWithSupplier(
      company,
      glbRegulationId,
      submission.companyId
    );
    var encodedData = Utils.encodeBase64(string);
    FormService.listFormStatusSupplier(pageNumber,
      itemsPerPage,
      "",
      sort,
      encodedData)
      .then((response) => {
        setForms([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const handleFormCheck = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const callbackModal = (boolVal) => {
    setIsConfirmation(false);
    callbackSubmissionStatus(false);
  };


  return (
    <>
      {isConfirmation && (
        <ConfirmationModal
          modalShow={true}
          messageText={messageConfirmation}
          callbackModal={callbackModal}
        />
      )}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          < Modal.Title as="h5">
            {t("Assessmentsharedwithsupplier.label")} - {submission.legalName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Table responsive="sm">
              <thead>
                <tr>
                  {/* <th></th> */}
                  <th>{t("AssessmentTitle.label")}</th>
                  <th>{t("Description.label")}</th>
                  <th>{t("SubmissionStatus.label")}</th>
                  <th>{t("ReceivedDate.label")}</th>
                  <th>{t("SubmittedDate.label")}</th>
                </tr>
              </thead>
              <tbody>
                {forms.length > 0 ? (
                  forms.map((item, index) => (
                    <tr key={index}>
                      {/* <td>
                         <Form.Check
                           inline
                           name={item.id}
                           type="checkbox"
                           id={item.id}
                           onChange={handleFormCheck}
                         />
                       </td> */}
                      <td>
                        {item.formName}
                        {/* <p className="m-0">
                           {item.regulation && item.regulation.name}
                         </p> */}
                      </td>
                      <td>{item.description}</td>
                      <td>{STATUS[item.status]}</td>
                      <td>{moment(item.sharedOn).format("MMM DD, YYYY")}</td>
                      <td>{item.submittedOn === null ? "-" : moment(item.submittedOn).format("MMM DD, YYYY")}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            {t("Ok.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withTranslation()(SubmissionStatusModal);
